import { type Map } from 'immutable';

import { SUPPORTED_ICONS } from '@hivebrite/design-system/SocialButton';

import { type Topic } from 'hb-react/shared/apps/Topics/containers/TopicShowContainer/types';

interface SocialLink {
  link_type: string;
  url: string;
}

interface SocialLinksMap {
  social_links: {
    [key: string]: Map<string, SocialLink | string>;
  };
}

interface GetGroupHeaderSocialsProperties {
  socialLinks: Map<string, SocialLinksMap>;
  topic: Topic;
}

// TODO: clean this function (Card Jira created)
export const getGroupHeaderSocials = ({
  socialLinks,
  topic,
}: GetGroupHeaderSocialsProperties) =>
  topic.social_links
    .map((linkId) => socialLinks.getIn(['social_links', linkId.toString()]))
    .filter((linkModel) => linkModel !== undefined)
    .map((linkModel) => linkModel.toJS())
    .filter(({ link_type: linkType }) =>
      Object.keys(SUPPORTED_ICONS).includes(linkType),
    )
    .map(({ link_type: type, url }) => ({
      type,
      url,
      title: SUPPORTED_ICONS[type]?.title || '',
      dataTestId: `social-link-${type}`,
    }));
